import {
  siAirtable,
  siAsana,
  siBitbucket,
  siBox,
  siCalendly,
  siCanva,
  siClickup,
  siConfluence,
  siDropbox,
  siFigma,
  siGithub,
  siGitlab,
  siGoogledocs,
  siGoogledrive,
  siGoogleforms,
  siGooglemeet,
  siGooglesheets,
  siGoogleslides,
  siLinear,
  siLoom,
  siMiro,
  siNotion,
  siQuip,
  siSlack,
  siTrello,
  siZoom,
} from "simple-icons/icons";
import screentop from "../brand-logos/screentop.png";
import boardgamegeek from "../brand-logos/boardgamegeek.ico";
import dextrous from "../brand-logos/dextrous.png";

const domainToBrand = {
  "airtable.com": "airtable",
  "asana.com": "asana",
  "atlassian.net": "confluence",
  "bitbucket.org": "bitbucket",
  "box.com": "box",
  "calendly.com": "calendly",
  "canva.com": "canva",
  "clickup.com": "clickup",
  "docs.google.com": "googledocs",
  "drive.google.com": "googledrive",
  "dropbox.com": "dropbox",
  "figma.com": "figma",
  "forms.google.com": "googleforms",
  "github.com": "github",
  "gitlab.com": "gitlab",
  "linear.app": "linear",
  "loom.com": "loom",
  "meet.google.com": "googlemeet",
  "miro.com": "miro",
  "notion.so": "notion",
  "quip.com": "quip",
  "sheets.google.com": "googlesheets",
  "slack.com": "slack",
  "slides.google.com": "googleslides",
  "trello.com": "trello",
  "zoom.us": "zoom",
};

const domainToSimpleIcon = {
  "airtable.com": siAirtable,
  "asana.com": siAsana,
  "atlassian.net": siConfluence,
  "bitbucket.org": siBitbucket,
  "box.com": siBox,
  "calendly.com": siCalendly,
  "canva.com": siCanva,
  "clickup.com": siClickup,
  "docs.google.com": siGoogledocs,
  "drive.google.com": siGoogledrive,
  "dropbox.com": siDropbox,
  "figma.com": siFigma,
  "forms.google.com": siGoogleforms,
  "github.com": siGithub,
  "gitlab.com": siGitlab,
  "linear.app": siLinear,
  "loom.com": siLoom,
  "meet.google.com": siGooglemeet,
  "miro.com": siMiro,
  "notion.so": siNotion,
  "quip.com": siQuip,
  "sheets.google.com": siGooglesheets,
  "slack.com": siSlack,
  "slides.google.com": siGoogleslides,
  "trello.com": siTrello,
  "zoom.us": siZoom,
};

const customIcons = {
  "screentop.gg": {
    slug: screentop,
    title: "ScreenTop",
    fullPath: true,
  },
  "boardgamegeek.com": {
    slug: boardgamegeek,
    title: "BoardGameGeek",
    fullPath: true,
  },
  "www.dextrous.com.au": {
    slug: dextrous,
    title: "Dextrous",
    fullPath: true,
  },
  "dextrous.com.au": {
    slug: dextrous,
    title: "Dextrous",
    fullPath: true,
  },
};

/**
 * @param {string} url
 */
export const getBrandIcon = (url) => {
  if (url.startsWith("https://docs.google.com/spreadsheets/")) {
    return siGooglesheets;
  }

  const hostname = new URL(url).hostname;
  const matchedEntry = Object.entries(domainToBrand).find(([domain]) => hostname.includes(domain));
  if (!matchedEntry) {
    return customIcons[hostname] || null;
  }

  const slug = matchedEntry[1];
  const iconKey = `si${slug.charAt(0).toUpperCase() + slug.slice(1)}`;

  return domainToSimpleIcon[iconKey] || null;
};
